import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { useTranslation } from 'react-i18next';
import { IContractInputBaseProps } from '../base/ContractInputBase';
import './ContractInputParagraphSection.scss';

interface IContractInputParagraphSectionProps
  extends Omit<IContractInputBaseProps, 'name'> {}

const ContractInputParagraphSection = ({
  id,
  ...props
}: IContractInputParagraphSectionProps) => {
  const { itemNameById } = useFormikContractHelpers();
  const { t } = useTranslation();

  return (
    <Contract.Input.Base
      {...props}
      id={id}
      classNames={['contract-section-input', 'contract-paragraph-section-input']}
      name={`${itemNameById(id)}.content`}
      placeholder={t('input.placeholder.paragraph-section-title')}
    />
  );
};

export default ContractInputParagraphSection;
